import { getConfig } from 'owa-service/lib/config';
import type { TokenResponseExtended as TokenResponse } from 'owa-service/lib/tokenResponseExtended';
import type { TokenRequestParams } from 'owa-tokenprovider-utils';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import type TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';
import type { TokenPerformanceLogger } from './TokenPerformanceLogger';

export async function getTokenFromMsal(
    tokenRequestParams: TokenRequestParams,
    perfLog: TokenPerformanceLogger
): Promise<TokenResponse | undefined> {
    if (!tokenRequestParams.mailboxInfo) {
        perfLog.addCustomProperty(
            'MailboxInfo:',
            tokenRequestParams.apiName + ' fallback to module context'
        );
    }

    const config = getConfig();
    const mailboxInfo = tokenRequestParams.mailboxInfo ?? getModuleContextMailboxInfo();
    var tokenResponse = await config.getMsalToken?.(
        mailboxInfo,
        tokenRequestParams.apiName ?? 'Undefined apiName',
        tokenRequestParams.resource,
        tokenRequestParams.scope,
        tokenRequestParams.requestId,
        tokenRequestParams.wwwAuthenticateHeader,
        tokenRequestParams.claims,
        tokenRequestParams.suppressInteractiveFallback
    );

    if (tokenResponse?.TokenResultCode != 0) {
        config.checkAndHandleMSALFailure?.(tokenResponse);
    }

    perfLog.addCheckpoint('getTokenFromMSAL_FetchedFromMSAL');

    return tokenResponse;
}
